const clientReport = {
  clientReports: 'Client report',
  showing: 'showing',
  clientReportsOf: 'clients of',
  noClientReportsFound: 'No client reports found',
};

export default clientReport;
